import React, { useState, useEffect } from 'react'
import { DatePicker, Space } from 'antd';
import CalenderCard from './CalenderCard';
import WeeklyData from './WeeklyData';
import cubejs from "@cubejs-client/core";
import { handleQueryMyOnboardCount, handleQueryMyCaseCount, handleQueryMyOverallCaseCount,handleMyIncentiveAmount,handleQueryMyClientCaseCount } from './utils';
import dayjs from 'dayjs'
import MonthlyData from './MonthlyData';
import ClientModal from './ClientModal';
const { RangePicker } = DatePicker;

const days = {
    'Monday': 'Mon',
    'Tuesday': 'Tue',
    'Wednesday': 'Wed',
    'Thursday': 'Thu',
    'Friday': 'Fri',
    'Saturday': 'Sat',
    'Sunday': 'Sun'
}

export const dateFormat = (date) => {
    const dateObject = new Date(date);
    // Extract the year, month, and day from the date object
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObject.getDate().toString().padStart(2, '0');
    // Construct the output date string in the format "yyyy-mm-dd"
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString
}

export const getPreiviousDate = (date) => {
    const currentDate = new Date(date);

    // Get the previous date by subtracting one day from the current date
    const previousDate = new Date(currentDate);
    previousDate.setDate(previousDate.getDate() - 1);

    // Extract the year, month, and day from the previous date
    const year = previousDate.getFullYear();
    const month = (previousDate.getMonth() + 1).toString().padStart(2, '0');
    const day = previousDate.getDate().toString().padStart(2, '0');

    // Construct the output date string in the format "yyyy-mm-dd"
    const previousDateString = `${year}-${month}-${day}`;
    return previousDateString
}

function MyContribution({ accessLevel, radioValue,modality }) {
    const [data, setData] = useState([
    ]
    )
    const [contributionCase, setContributionCase] = useState([])
    const [overallCaseCount, setOverallCaseCount] = useState([])
    const [clientLevel,setClientLevel]=useState([])
    const [selectedRangeOnboard, setSelectedRangeOnboard] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);

    const [selectedRangeCase, setSelectedRangeCase] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);

    const [overallCaseDate, setOverallCaseDate] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);
    const [modalOpen,setIsModalOpen]=useState(false)
    const [loader,setLoader]=useState(false)

    const handleRangeChange = (value) => {
        setSelectedRangeOnboard(value);
    };

    const getClientLevelData=async(cubejsApi)=>{
        setLoader(true)
        try {
            await cubejsApi
                .load(handleQueryMyClientCaseCount(accessLevel?.name, modalOpen, 'my',modality))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            client_id: data['Contribution.client_fk'],
                            client_name: data['Contribution.client_name'],
                            total_case: data['Contribution.total_case_count']
                        }
                    })
                    setClientLevel(modifiedData)
                    setLoader(false)
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }

    }

    useEffect(()=>{
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
            if(modalOpen){
                    getClientLevelData(cubejsApi)
            }else{
                setClientLevel([])
            }
    },[modalOpen])


    const handleRangeChangeCase = (value) => {
        setSelectedRangeCase(value);
    };

    const handleOverallChangeCase = (value) => {
        setOverallCaseDate(value);
    };



   

    const handleOnboardCount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(selectedRangeOnboard[0]?.$d))
        const endDate = dateFormat(selectedRangeOnboard[1]?.$d)
        setData([])
        try {
            await cubejsApi
                .load(handleQueryMyOnboardCount(accessLevel?.name, startDate, endDate, 'my',modality))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Onboarded_date']?.split('T')[0],
                            day: days[data['Contribution.onboarded_day_name']],
                            count: data['Contribution.client_count']
                        }
                    })
                    //console.log(modifiedData)
                    setData(fillMissingDatesWithZeroCount(modifiedData, selectedRangeOnboard))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }


    const handleCaseCount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(selectedRangeCase[0]?.$d))
        const endDate = dateFormat(selectedRangeCase[1]?.$d)
        setContributionCase([])
        try {
            await cubejsApi
                .load(handleQueryMyCaseCount(accessLevel?.name, startDate, endDate, 'my',modality))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Date']?.split('T')[0],
                            day: days[data['Contribution.day_name']],
                            count: data['Contribution.total_case_count']
                        }
                    })
                    //console.log(modifiedData)
                    setContributionCase(fillMissingDatesWithZeroCount(modifiedData, selectedRangeCase))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const getDayName = (dayIndex) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[dayIndex];
    };

    const fillMissingDatesWithZeroCount = (data, selectedDate) => {
        const filledData = [];
        const startDate = new Date(dateFormat(selectedDate?.[0]?.$d));
        const endDate = new Date(dateFormat(selectedDate?.[1]?.$d));
        let currentIndex = 0;

        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const dateString = currentDate.toISOString().split('T')[0];
            const existingEntry = data.find(item => item.date === dateString);

            if (existingEntry) {
                filledData.push(existingEntry);
            } else {
                filledData.push({ count: 0, date: dateString, day: getDayName(currentDate.getDay()) });
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }
        //console.log(filledData)
        // setFilledDates(filledData)
        return filledData;
    };



    const handleIncentiveAmount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(overallCaseDate[0]?.$d))
        const endDate = dateFormat(overallCaseDate[1]?.$d)
        setOverallCaseCount([])
        try {
            await cubejsApi
                .load(handleMyIncentiveAmount(accessLevel?.name, startDate, endDate, 'my',modality))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Date']?.split('T')[0],
                            day: days[data['Contribution.day_name']],
                            count: data['Contribution.incentive_amount']
                        }
                    })
                    //console.log(modifiedData)
                    setOverallCaseCount(fillMissingDatesWithZeroCount(modifiedData, overallCaseDate))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    function getMonthName(monthIndex) {
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "June",
            "July", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        return months[monthIndex];
    }


    const seperateMonthData = (separate) => {
        const separatedData = {};
    
        separate.forEach(item => {
            const yearMonth = item.date.slice(0, 7); // Extract "YYYY-MM" from the date string
            if (!separatedData[yearMonth]) {
                separatedData[yearMonth] = []; // Initialize the array if it doesn't exist
            }
            separatedData[yearMonth].push({ ...item, yearMonth: yearMonth }); // Add yearMonth info to each item
        });
    
        // Convert separated data to an array of objects, sorted by year and month
        const result = Object.keys(separatedData)
            .sort((a, b) => new Date(b) - new Date(a)) // Sort based on year and month
            .map(yearMonth => ({
                yearMonth: yearMonth, 
                data: separatedData[yearMonth]
            }));
    
        console.log(result);
        return result;
    };
    


    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && selectedRangeOnboard?.[0] && selectedRangeOnboard?.[1] && modality) {
            
            handleOnboardCount(cubejsApi)
        }
    }, [accessLevel, selectedRangeOnboard,modality])

    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && selectedRangeCase?.[0] && selectedRangeCase?.[1]&& modality) {
            handleCaseCount(cubejsApi)
        }
    }, [accessLevel, selectedRangeCase,modality])

    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && overallCaseDate?.[0] && overallCaseDate?.[1]&& modality) {
            handleIncentiveAmount(cubejsApi)
        }
    }, [accessLevel, overallCaseDate,modality])

    return (
        <div className='contribution-first-table' >

            <div className='contribution-first-table-first' >
                <div className='date-ranger'>
                    <div > Onboard Count</div>
                    <div>
                        <RangePicker value={selectedRangeOnboard}
                            onChange={handleRangeChange}
                             />
                    </div>
                </div>
                <div>

                    <div>
                        <div > Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData radioValue={radioValue} data={data} selectedRangeOnboard={selectedRangeOnboard} dateFormat={dateFormat} />
                    }

                    {radioValue === 'monthly' && <div className='monthly-stats'>
                        {seperateMonthData(data)?.map((data1, id) => (

                            <MonthlyData key={id} data={data1?.data} selectedRangeOnboard={selectedRangeOnboard} dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }
                </div>
            </div>

            <div>
                <div className='date-ranger'>
                    <div> Case Count</div>
                    <div>
                        <RangePicker value={selectedRangeCase}
                            onChange={handleRangeChangeCase}  />
                    </div>
                </div>

                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData contribution={{
                            type:'my',
                            isModelOpen:modalOpen,
                            card:'case',

                        }}  setIsModalOpen={setIsModalOpen} radioValue={radioValue} data={contributionCase} selectedRangeOnboard={selectedRangeCase} dateFormat={dateFormat} />
                    }


                    {radioValue === 'monthly' && <div className='monthly-stats'>
                        {seperateMonthData(contributionCase)?.map((data1, id) => (

                            <MonthlyData contribution={{
                                type:'my',
                                card:'case',
                                isModelOpen:modalOpen,
                            }
                            }      setIsModalOpen={setIsModalOpen} key={id} data={data1?.data} selectedRangeOnboard={selectedRangeCase} dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }
                </div>


            </div>
{/* 
            <div>
                <div className='date-ranger'>
                    <div> Incentive Amount</div>
                    <div>
                        <RangePicker value={overallCaseDate}
                            onChange={handleOverallChangeCase}  />
                    </div>
                </div>

                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData  radioValue={radioValue} data={overallCaseCount} selectedRangeOnboard={overallCaseDate} dateFormat={dateFormat} amount={'amount'} />
                    }

                    {radioValue === 'monthly' && <div className='monthly-stats'>
                        {seperateMonthData(overallCaseCount)?.map((data1, id) => (

                            <MonthlyData  key={id} data={data1?.data} selectedRangeOnboard={overallCaseDate} dateFormat={dateFormat} amount={'amount'}  />

                        ))
                        }
                    </div>
                    }

                </div>


            </div> */}


            <ClientModal isModalOpen={modalOpen} setIsModalOpen={setIsModalOpen} data={clientLevel} loading={loader}/>

        </div>
    )
}

export default MyContribution
